export enum MimeTypes {
  IMAGE_JPEG = "image/jpeg",
  IMAGE_PNG = "image/png",
  IMAGE_GIF = "image/gif",
  IMAGE_WEBP = "image/webp",
  APPLICATION_EXCEL = "application/vnd.ms-excel",
  APPLICATION_WORD = "application/vnd.ms-word",
  APPLICATION_PDF = "application/pdf",
  APPLICATION_ZIP = "application/zip",
  APPLICATION_PAC = "application/x-ns-proxy-autoconfig",
  APPLICATION_JSON = "application/json",
  // Add more MIME types as needed
}
